export default "__VITE_ASSET__BBmpGzP4__"